<template>
  <div class="container is-fullhd">
    <section class="section container__section-ebook">
     <b-message type="is-info" title="Want to read this ebook?" has-icon v-if="!isLoading && !isAuthenticated">
       <div class="buttons">
         <button class="button is-primary" @click="goToSignUp">Create an account</button><button class="button is-primary" @click="goToSignIn">Sign in</button>
       </div>
     </b-message>

      <div class="card">
        <single-ebook-card-content/>
        <footer class="modal-card-foot">
          <button type="button" v-bind:class="{ 'is-loading': isContinueEbookButtonLoading }" class="button is-primary" @click="sendSection()" v-if="isReadEbook && isAuthenticated">
            <span class="icon">
              <i class="mdi mdi-email"></i>
            </span>
            <span>Send Email</span>
          </button>
          <button v-bind:class="{ 'is-loading': isStartEbookButtonLoading }" class="button is-primary" @click="startEbook()" :disabled="isStartEbookButtonDisabled" v-if="!isReadEbook && isAuthenticated">
            Start Reading!
          </button>
          <button v-if="internalEbook.amazonAffiliateUrl" class="button is-secondary" @click="clickOnAmazonLink()">
            <span>Learn More</span>
          </button>
        </footer>
      </div>
    </section>
  </div>
</template>

<script>
import ebooksService from '@/services/ebooks.service'
import singleEbookCardContent from '@/components/single-ebook-card-content'

export default {
  name: 'singleEbookPage',
  props: {
    ebookCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      internalEbook: {}
    }
  },
  created () {
    this.$store.dispatch('getEbookByCode', { ebookCode: this.ebookCode })
  },
  watch: {
    getEbook (value) {
      this.internalEbook = value
    }
  },
  methods: {
    clickOnAmazonLink () {
      this.$store.dispatch('updateEbookOnAmazonLinkClick')
    },
    goToSignIn () {
      this.$router.push('/signin')
    },
    goToSignUp () {
      this.$router.push('/signup')
    },
    startEbook () {
      this.$store.dispatch('startReadEbookFromEbookPage', this.internalEbook)
    },
    sendSection () {
      const user = this.isAuthenticated
      if (user) {
        this.$store.dispatch('reSendChapterFromEbookPage', { ebookId: this.internalEbook.id, sectionId: this.internalEbook.sectionId, user: user.id })
      }
    }
  },
  computed: {
    canStartReadingEbook () {
      return this.$store.getters.getUserTicketsCount > 0
    },
    getEbook () {
      return this.$store.getters.getEbook
    },
    getEbookCover () {
      return ebooksService.getEbookCover(this.internalEbook.title, this.internalEbook.coverUrl)
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isContinueEbookButtonLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'continueEbookButton' && localLoading.active
    },
    isLoading () {
      return this.$store.getters.isFullPageLoading
    },
    isReadEbook () {
      const ebook = this.getEbook
      return ebook && ebook.isRead
    },
    isStartEbookButtonLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'startEbookButton' && localLoading.active
    },
    isStartEbookButtonDisabled () {
      return !this.canStartReadingEbook
    }
  },
  components: {
    singleEbookCardContent
  }
}
</script>

<style>
.container__section-ebook {
  min-height: 88vh;
}
</style>
